import React from 'react';
import { Redirect } from 'react-router-dom';
import config from '@/configs/config';
import AboutUsApp from './pages/AboutUs';
import PartnerProvider from './pages/PartnerProvider';
import PartnerLocation from './pages/PartnerLocation';
import PartnerSaasPro from './pages/PartnerSaasPro';
import PreOrderApp from './preorder/App';
import MenuApp from './menu';
import LocationApp from './location';
import Faq from './faq';
import WishList from './wishlist';
import Register from './register';
import Login from './login';
import ProvidersApp from './providers';
import User from './user';
import AuthPage from './preorder/containers/AuthPage';
import EcApp from './ec';
import ECSearchComponent from './ec/components/search/SearchComponent';
import ECCartComponent from './ec/components/cart/CartComponent';
import PartnerResidential from './pages/PartnerResidential';

const routes = {
  personalOrders: {
    title: '訂單記錄',
    path: '/personal/purchased-orders',
    children: <Redirect to={{
      pathname: '/pre-orders/personal/purchased-orders',
      search: window.location.search,
    }}
    />,
  },
  partner_provider: {
    title: '成為餐食夥伴',
    path: '/partner_provider',
    children: <PartnerProvider formLink="https://forms.gle/gkdH3xAWwC6jhiMp8" />,
  },
  partner_residential: {
    title: '社區合作方案',
    path: '/partner_residential',
    children: <PartnerResidential formLink="https://forms.gle/k9Pjya8NkgiPw5fw5" />,
  },
  partner_location: {
    title: '場域進駐方案',
    path: '/partner_location',
    children: <PartnerLocation formLink="https://forms.gle/9bgN8Yv5tCSKpyyEA" />,
  },
  partner_saas_pro: {
    title: '客製品牌門市',
    path: '/partner_saas_pro',
    children: <PartnerSaasPro formLink="https://forms.gle/KQxjHrZRx31rRGq4A" />,
  },
  partner_provider_ad: {
    title: '成為餐食夥伴',
    path: '/partner_provider_ad',
    children: <PartnerProvider formLink="https://forms.gle/xxQNrPSEgJ1hc2ub9" />,
  },
  partner_location_ad: {
    title: '場域進駐方案',
    path: '/partner_location_ad',
    children: <PartnerLocation formLink="https://forms.gle/gsx5huCmtNQkYDpQ6" />,
  },
  partner_saas_pro_ad: {
    title: '客製品牌門市',
    path: '/partner_saas_pro_ad',
    children: <PartnerSaasPro formLink="https://forms.gle/ZvAFV9gsnnoyYxEA7" />,
  },
  partner_provider_yahoo_ad: {
    title: '成為餐食夥伴',
    path: '/partner_provider_yahoo_ad',
    children: <PartnerProvider formLink="https://forms.gle/fgoJBBptpUmc8BPB9" />,
  },
  partner_location_yahoo_ad: {
    title: '場域進駐方案',
    path: '/partner_location_yahoo_ad',
    children: <PartnerLocation formLink="https://forms.gle/w5e8h4Dc2tHUiv6z5" />,
  },
  partner_saas_pro_yahoo_ad: {
    title: '客製品牌門市',
    path: '/partner_saas_pro_yahoo_ad',
    children: <PartnerSaasPro formLink="https://forms.gle/mGudiaUmBQvQaM9X6" />,
  },
  menu: {
    title: '每日架上鮮食',
    path: '/menu',
    children: <MenuApp />,
  },
  location: {
    title: '營業據點',
    path: '/location',
    children: <LocationApp />,
  },
  faq: {
    title: '常見問與答',
    path: '/faq',
    children: <Faq />,
  },
  wishlist: {
    title: '上架通知我 願望清單',
    path: '/wishlist',
    children: <WishList />,
  },
  register: {
    title: '註冊會員',
    path: '/register',
    children: <Register />,
  },
  login: {
    title: '登入',
    path: '/login',
    children: <Login />,
  },
  edm202304_tpe: {
    title: '本月優惠',
    path: '/activity/edm202304_tpe',
  },
  edm202304_hsz: {
    title: '本月優惠',
    path: '/activity/edm202304_hsz',
  },
  edm202305_tpe: {
    title: '本月優惠',
    path: '/activity/edm202305_tpe',
  },
  edm202305: {
    title: '本月優惠',
    path: '/activity/edm202305',
  },
  providers: {
    title: '餐食夥伴',
    path: '/providers',
    children: <ProvidersApp />,
  },
  user: {
    title: '會員中心',
    path: '/user',
    children: <User />,
  },
  'pre-orders': {
    title: '選品線上購',
    path: '/pre-orders',
    children: <PreOrderApp />,
  },
  redeem: {
    title: '預購折抵',
    path: '/redeem',
    children: <Redirect to={{
      pathname: '/pre-orders/redeem',
      search: window.location.search,
    }}
    />,
  },
  ec_search: {
    title: <ECSearchComponent />,
    path: '/ec/search',
    children: <EcApp />,
  },
  ec_cart: {
    title: <ECCartComponent />,
    path: '/ec/cart',
    children: <EcApp />,
  },
  ec: {
    title: ' ',
    path: '/ec',
    children: <EcApp />,
  },
  auth: {
    title: '',
    path: '/auth',
    children: <AuthPage />,
  },
  about_us: {
    title: `關於${config.BrandNameTW}`,
    path: '/',
    children: <AboutUsApp />,
  },
};

const filteredRoutes = !config.modules ? routes : (
  Object.keys(routes).reduce((result, key) => {
    if (config.modules[key] === false) return result;
    return {
      ...result,
      [key]: routes[key],
    };
  }, {})
);
export default filteredRoutes;
